import { render, staticRenderFns } from "./circle-pie.vue?vue&type=template&id=bc505dd6&"
import script from "./circle-pie.vue?vue&type=script&lang=js&"
export * from "./circle-pie.vue?vue&type=script&lang=js&"
import style0 from "./circle-pie.vue?vue&type=style&index=0&id=bc505dd6&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports